export const UPDATE_EMAIL_NOTIFICATION_SETTINGS = 'UPDATE_EMAIL_NOTIFICATION_SETTINGS';
export const UPDATE_PUSH_NOTIFICATION_SETTINGS = 'UPDATE_PUSH_NOTIFICATION_SETTINGS';

// Phone Settings Update
export const SUBMIT_PHONE_NUMBER_UPDATE = 'SUBMIT_PHONE_NUMBER_UPDATE';
export const SUBMIT_PHONE_NUMBER_UPDATE_OTP = 'SUBMIT_PHONE_NUMBER_UPDATE_OTP';

export const UPDATE_SETTING = 'UPDATE_SETTING';
export const COMMIT_SETTINGS_CHANGES = 'COMMIT_SETTINGS_CHANGES';
export const COMMIT_PREFERENCES_CHANGES = 'COMMIT_PREFERENCES_CHANGES';
export const CLEAR_SETTINGS_CHANGES = 'CLEAR_SETTINGS_CHANGES';
export const UPDATE_PREFERENCES = 'UPDATE_PREFERENCES';
export const UPDATE_PREFERENCE_DESCRIPTORS = 'UPDATE_PREFERENCE_DESCRIPTORS';
export const UPDATE_PREFERENCE_INTERESTS = 'UPDATE_PREFERENCE_INTERESTS';
export const CLEAR_PREFERENCES_CHANGES = 'CLEAR_PREFERENCES_CHANGES';

// Message controls
export const UPDATE_MESSAGE_CONTROLS_SETTINGS = 'UPDATE_MESSAGE_CONTROLS_SETTINGS';
export const TOGGLE_ONLY_VERIFIED_USERS_MESSAGE_CONTROL =
  'TOGGLE_ONLY_VERIFIED_USERS_MESSAGE_CONTROL';
export const TOGGLE_ONLY_VERIFIED_USERS_MESSAGE_CONTROL_ERROR =
  'TOGGLE_ONLY_VERIFIED_USERS_MESSAGE_CONTROL_ERROR';
